import React, { Suspense } from "react"
import Content from "./Content/Content"
import Section from "./Section/Section"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"
import useDeviceType from "../../../hooks/useDeviceType"
import elementSplitter from "./utils/elementSplitter"

const Boxes = React.lazy(() => import("./Boxes/Boxes"))

type WidgetCardsProps = {
  children: React.ReactElement
  topSpace?: number | string
  gap?: number
  backgroundType?: BlurBackgroundProps["type"]
  simple?: boolean
}

const WidgetCards = ({
  children,
  topSpace = 100,
  gap = 30,
  backgroundType,
  simple,
}: WidgetCardsProps) => {
  //
  const DeviceType = useDeviceType()

  const { headers, paragraphs, svgs, components } = elementSplitter(children)

  // All Box
  const AllBox = paragraphs.map((paragraph, index) => ({
    svg: svgs.length === 4 ? svgs[index + 1] : svgs[index],
    title: headers[index + 1]?.props.children,
    description: paragraph.props.children,
  }))

  return (
    <Content columns={simple ? 3 : 2} topSpace={topSpace} gap={gap}>
      {!simple && (
        <Section x="left" style={{ justifyContent: "space-evenly" }}>
          {DeviceType !== "mobile" && DeviceType !== "tablet" && svgs[0]}
          {headers[0]}

          {/* Button */}
          {!simple && DeviceType !== "mobile" && DeviceType !== "tablet" && (
            <>{components}</>
          )}
        </Section>
      )}

      <Suspense fallback={<h4>Loading...</h4>}>
        <Boxes details={AllBox} simple={simple} />
      </Suspense>

      {/* Button Responsive */}
      {(simple || DeviceType === "mobile" || DeviceType === "tablet") && (
        <> {components}</>
      )}

      {backgroundType && (
        <BlurBackground direction="center" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetCards
